import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
@Injectable({
  providedIn: 'root'
})
export class CommunService {
  private apiUrls: { [key in 'bank' | 'pgl' | 'smt']: string } = {
    bank: environment.apiBankUrl, 
    pgl: environment.apiPglUrl,
    smt: environment.apiSmtUrl,
  };
  private getBaseUrl(): string {
    const userType = this.getUserType();
    return this.apiUrls[userType??'smt']+'/commun/';
  }
  private getUserType(): 'bank' | 'pgl' | 'smt' {
    const token = localStorage.getItem('x-access-token') || ''; // Fallback to an empty string if null
    if (!token) return 'smt';

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.type as 'bank' | 'pgl' | 'smt';
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'smt';
    }
  } 
  constructor(private http: HttpClient) { }
public time:any
    statuscollab:string[]=['traité']
    statusadmin:string[]=['en cours de supervision','supervisé','en cours de validation','validé','en cours de clôture','clôturé','à rectifié']
    nature: any[]=["Personne Physique","Personne Morale"];
    regimeimpot: any[]=["Réel","Forfait D'assiette","Non soumis"];
    natureactivite: any[]=["Profession Libérale","associations et syndics","Commerçant","Artisan","Salarié ou Pensionnaire"];
    activites: any[]=["Médecin","Avocat","Consultant","Expert","Infirmier","Masseur","Physiothérapeute","Ergothérapeute","Psychomotricien",
    "Diététicien","Orthophoniste","Orthoptiste","Sage-femmes","Architectes","Dessinateurs","Géomètres","Notaire","Huissiers notaire (de justice)", "Interprètes",
    "Ingénieurs-conseil","Topographes","Syndic des copropriétaires","Autre"];
    sousactivites: any[]=["Avocat","Avocat à la cour d'appel","Avocat à la cour de cassation","Médecin","Médecin spécialiste","Médecin dentiste","Médecin vétérinaire"];
    specialites: any[]=["Chirurgie générale",
    "Chirurgie pédiatrique",  
    "Chirurgie carcinologique",
    "Chirurgie cardio-vasculaire",
    "Chirurgie vasculaire périphérique",
    "Chirurgie neurologique",
    "Chirurgie orthopédique et traumatologique",
    "Chirurgie plastique, réparatrice et esthétique",
    "Chirurgie urologique",
    "Gynéco-obstétrique",
    "ORL",
    "Stomatologie et chirurgie maxillo-faciale",
    "Ophtalmologie",
    "Chirurgie thoracique",
    "Anesthésie réanimation",
    "Psychiatrie",
    "Pédo-psychiatrie",
    "Imagerie médicale",
    "Anatomie",
    "Anatomie et cytologie pathologiques",
    "Carcinologie médicale",
    "Cardiologie",
    "Dermatologie",
    "Endocrinologie",
    "Gastro-entérologie",
    "Hématologie clinique",
    "Maladies infectieuses",
    "Médecine d’urgence",
    "Médecine de travail",
    "Médecine interne",
    "Médecine légale",
    "Médecine physique, rééducation et réadaptation fonctionnelle",
    "Médecine préventive et communautaire",
    "Néphrologie",
    "Neurologie",
    "Nutrition et maladies nutritionnelles",
    "Pédiatrie",
    "Pneumologie",
    "Radiothérapie carcinologique",
    "Réanimation médicale",
    "Rhumatologie",
    "Biophysique et médecine nucléaire",
    "Génétique",
    "Biologie médicale option biochimie",
    "Biologie médicale option hématologie",
    "Biologie médicale option parasitologie",
    "Biologie médicale option microbiologie",
    "Biologie médicale option immunologie",
    "Histo-embryologie",
    "Pharmacologie",
    "Physiologie et explorations fonctionnelles"];
    sousspecialites: any[]=[];
    sousactivitesavocat: string[]=["Avocat","Avocat à la cour d'appel","Avocat à la cour de cassation"];
    sousactivitesmedecin: string[]=["Médecin","Médecin spécialiste","Médecin dentiste","Médecin vétérinaire"];
    specialitesmedecinspecialiste: string[]=["Chirurgie générale",
    "Chirurgie pédiatrique",
    "Chirurgie carcinologique",
    "Chirurgie cardio-vasculaire",
    "Chirurgie vasculaire périphérique",
    "Chirurgie neurologique",
    "Chirurgie orthopédique et traumatologique",
    "Chirurgie plastique, réparatrice et esthétique",
    "Chirurgie urologique",
    "Gynéco-obstétrique",
    "ORL",
    "Stomatologie et chirurgie maxillo-faciale",
    "Ophtalmologie",
    "Chirurgie thoracique",
    "Anesthésie réanimation",
    "Psychiatrie",
    "Pédo-psychiatrie",
    "Imagerie médicale",
    "Anatomie",
    "Anatomie et cytologie pathologiques",
    "Carcinologie médicale",
    "Cardiologie",
    "Dermatologie",
    "Endocrinologie",
    "Gastro-entérologie",
    "Hématologie clinique",
    "Maladies infectieuses",
    "Médecine d’urgence",
    "Médecine de travail",
    "Médecine interne",
    "Médecine légale",
    "Médecine physique, rééducation et réadaptation fonctionnelle",
    "Médecine préventive et communautaire",
    "Néphrologie",
    "Neurologie",
    "Nutrition et maladies nutritionnelles",
    "Pédiatrie",
    "Pneumologie",
    "Radiothérapie carcinologique",
    "Réanimation médicale",
    "Rhumatologie",
    "Biophysique et médecine nucléaire",
    "Génétique",
    "Biologie médicale option biochimie",
    "Biologie médicale option hématologie",
    "Biologie médicale option parasitologie",
    "Biologie médicale option microbiologie",
    "Biologie médicale option immunologie",
    "Histo-embryologie",
    "Pharmacologie",
    "Physiologie et explorations fonctionnelles"];
    activitesassociation: string[];
    activitesassociations: any[]=["Syndic des copropriétaires"];
    activitesliberales: string[]=["Médecin","Avocat","Consultant","Expert","Infirmier","Masseur","Physiothérapeute","Ergothérapeute","Psychomotricien",
    "Diététicien","Orthophoniste","Orthoptiste","Sage-femmes","Architectes","Dessinateurs","Géomètres","Notaire","Huissiers notaire (de justice)", "Interprètes",
    "Ingénieurs-conseil","Topographes","Autre"];
    statuts: string[]=['','crée','encours','acceptée','rejetée','chb émis','représentée','pré-arbitrage','clôturé',
  'pré-arbitrage rejetée','arbitrage','arbitrage rejeté','arbitrage accepté','Arbitrage fav. émetteur','Arbitrage Fav. acquéreur']
  topics=[
    'Activité non autorisée sur ma carte','Erreurs de facturation ou problèmes d\'abonnement','Problèmes avec mon achat'
    ,'Opération de retrait avec problème'
  ] 
  subtopics = [
    { subtopic: "Carte perdue et utilisée sans ma permission", topic: "Activité non autorisée sur ma carte" },
    { subtopic: "Carte volée et utilisée sans ma permission", topic: "Activité non autorisée sur ma carte" },
    { subtopic: "Je pense que l'abonnement ou le paiement récurrent a été configuré par quelqu'un d'autre", topic: "Activité non autorisée sur ma carte" },
    
    { subtopic: "J'ai un problème avec un abonnement ou un paiement récurrent", topic: "Erreurs de facturation ou problèmes d'abonnement" },
    { subtopic: "Transaction ou service annulé - montant non remboursé", topic: "Erreurs de facturation ou problèmes d'abonnement" },
    { subtopic: "Un montant différent m'a été facturé", topic: "Erreurs de facturation ou problèmes d'abonnement" },
    { subtopic: "Transaction facturée plus qu'une fois", topic: "Erreurs de facturation ou problèmes d'abonnement" },
    { subtopic: "Transaction payée par un autre moyen", topic: "Erreurs de facturation ou problèmes d'abonnement" },
    
    { subtopic: "Je n'ai pas reçu l'objet ou le service où date et heure de livraison non respectés", topic: "Problèmes avec mon achat" },
    { subtopic: "J'ai reçu un objet ou un service différent ou ne correspondant pas à sa description", topic: "Problèmes avec mon achat" },
    { subtopic: "Marchandise contrefaite", topic: "Problèmes avec mon achat" },
    { subtopic: "Demande de remboursement acceptée et non traitée par le commerçant", topic: "Problèmes avec mon achat" },
    
    { subtopic: "Retrait GAB non servi", topic: "Opération de retrait avec problème" },
    { subtopic: "Retrait GAB servi partiellement", topic: "Opération de retrait avec problème" }
  ];
  possibletypes = [
    { type: "Clientpor", label: "Client Porteur",role:["userbanque","adminbanque"] },
    { type: "Clientcomm", label: "Client commercant",role:["userbanque","adminbanque"] },
    { type: "Metier", label: "Banque",role:["userbanque","adminbanque"] },
    { type: "Agence", label: "Agence",role:["userbanque","adminbanque"] },
    { type: "comite arbitrage", label: "Comité arbitrage",role:["superadmin"] },

  ];
  getcurrenttime() {
      return new Promise((resolve, reject) => {
        const baseUrl = this.getBaseUrl();
        this.http.get(`${baseUrl}/currenttime/`).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });
    }
    executebatch(date: Date) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.getBaseUrl();

        this.http.get(`${baseUrl}/executebatch/${date}`).subscribe(
        (response: any) => {

          resolve(response);
        },
        (error) => {
          reject(error); 
        }
      );
    });
    }
    filterByValue(array, value) {
      if(array!=undefined)
      {
        return array.filter((data) =>  JSON.stringify(data).toLowerCase().indexOf(value.toLowerCase()) !== -1);
      }     
     }
     findByValue2(array, value) {
      if(array!=undefined)
      {
        return array.find((data) =>  JSON.stringify(data).toLowerCase().indexOf(value.toLowerCase()) !== -1);
      }     
     }
}